<template>
  <div
    class="widget-alert d-flex gap-2 neutral--text lh-20"
    :class="{
      'widget-alert--is-rounded': isRounded,
    }"
  >
    <widget-icon
      class="color--orange flex-shrink-0 flex-grow-0 mt-2px"
      name="warning"
      size="16px"
    />

    <div class="flex-shrink-1 flex-grow-1 truncate-lines">
      <slot />
    </div>

    <div class="flex-shrink-0 flex-grow-0 lh-0">
      <slot name="action">
        <widget-button
          is-icon-only
          color="secondary"
          size="20"
          view="transparent"
          @click="$emit('close')"
        >
          <widget-icon
            name="close"
            size="16px"
          />
        </widget-button>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import WidgetButton from '@widgets/shared/components/WidgetButton.vue'

defineProps<{
  isRounded?: boolean
}>()

defineEmits<{
  (e: 'close'): void
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';
@import '@/styles/mixins.scss';

.widget-alert {
  background-color: $orange100;
  padding: 8px 10px;
  box-shadow: 0 1px 4px 0 rgba($black, 0.16);

  &--is-rounded {
    border-radius: $border-radius-x;
  }
}

.lh-0 {
  line-height: 0;
}

.truncate-lines {
  @include truncate(20);
  word-break: break-word;
}
</style>
